import { FulfillmentType } from '@/lib/enums/FulfillmentType'

export type FulfillmentTypeEntry = (typeof FulfillmentType)[keyof typeof FulfillmentType]

/** The fulfillment type entry (name, icon, badge variant) for a stored value such as `pickup`. */
export function getFulfillmentTypeByValue(
  value: string | null | undefined
): FulfillmentTypeEntry | undefined {
  return Object.values(FulfillmentType).find((type) => type.Value === value)
}
